/* eslint-disable  */
import { APIClient } from "./_api";
const endpoint = "/saleManagerManagement";

export function getAll(query) {
  return APIClient.post(`${endpoint}/filter`, query);
}

export function getAllUser() {
  return APIClient.get(`/User/saleManager`);
}

export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}

export function edit(value) {
  return APIClient.put(`${endpoint}/${value.id}`, { inList: value.inList });
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}
